import type { CSSProperties } from 'react'

/** 6-digit hex для чипа метки (как в classic: фон `#RRGGBB33`, бордер `#RRGGBB80`). */
export function normalizeTagColorHex(color: string | null | undefined): string {
  const c = (color || '').trim()
  if (/^#[0-9A-Fa-f]{6}$/i.test(c)) return c.slice(0, 7)
  if (/^#[0-9A-Fa-f]{3}$/i.test(c)) {
    const r = c[1]
    const g = c[2]
    const b = c[3]
    return `#${r}${r}${g}${g}${b}${b}`.toLowerCase()
  }
  return '#6c7ae0'
}

export function ticketTagChipStyle(hex: string): CSSProperties {
  return {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    padding: '1px 6px 1px 5px',
    borderRadius: 9999,
    fontSize: 11,
    fontWeight: 500,
    lineHeight: 1.2,
    maxWidth: 176,
    color: 'var(--mantine-color-text)',
    backgroundColor: `${hex}33`,
    border: `1px solid ${hex}80`,
  }
}
